import { render, staticRenderFns } from "./TeamBySector.vue?vue&type=template&id=01d5b336"
import script from "./TeamBySector.vue?vue&type=script&lang=js"
export * from "./TeamBySector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TeamBySectorMember: require('/home/runner/work/marketing/marketing/components/TeamBySectorMember.vue').default,TeamBySectorMemberInfo: require('/home/runner/work/marketing/marketing/components/TeamBySectorMemberInfo.vue').default})
